interface DrawerAutoCloseOptions {
  desktopBreakpoint?: string
  closeOnRouteChange?: boolean
  focusOnAutoClose?: MaybeRefOrGetter<HTMLElement | null>
}

export function useDrawerAutoClose(open: Ref<boolean>, options: DrawerAutoCloseOptions = {}) {
  const { desktopBreakpoint = '(min-width: 1024px)', closeOnRouteChange = true, focusOnAutoClose } = options

  const isDesktop = useMediaQuery(desktopBreakpoint)
  const router = useRouter()

  watch(isDesktop, (desktop) => {
    if (desktop) {
      if (open.value) {
        toValue(focusOnAutoClose)?.focus()
      }

      open.value = false
    }
  })

  if (closeOnRouteChange) {
    watch(
      () => router.currentRoute.value.path,
      () => {
        open.value = false
      },
    )
  }
}
